<template>
  <!-- 首页 -->
  <div class="home">
    <!-- 背景图 -->
    <img v-if="imageUrl" ref="backgroundImage" class="container" :src="imageUrl" 
      :class="{ 'image-loaded': imageLoaded }" 
      @load="handleImageLoad" @error="handleImageError" alt="">
    <!-- 旋转月球 -->
    <div class="xzyq" style="z-index: 1;">
      <div class="light">
        <div class="rotate">
          <img src="@/assets/earth2.png" alt="">
        </div>
      </div>
    </div>
    <!-- 系统更新入口和租户菜单 -->
    <div class="header-right-menu" style="z-index: 11;">
      <!-- 系统更新入口 -->
      <div class="sys-update-wrapper">
        <div class="sys-update-entry" :class="{ 'highlight': showUpdateGuide }" @click="handleShowUpdateNotice" title="系统更新通知">
          <img src="@/assets/sysUpdate/remind.svg" alt="系统更新" />
        </div>
        <!-- 引导气泡 -->
        <div v-if="showUpdateGuide" class="update-guide-popover">
          <div class="popover-content">
            点击这里可以继续查看系统更新通知哦！
          </div>
          <div class="popover-btn" @click="handleCloseGuide">知道啦</div>
          <div class="popover-arrow"></div>
        </div>
      </div>
      <!-- 租户菜单 -->
      <div class="zhcd">
        <avatar-dropdown :menu="showMenu" :current-user="currentUser" color-value="#ffffff" />
      </div>
    </div>
    <!-- 星星动效 -->
    <div class="particles-wrapper" style="z-index: 2;" id="particlesId">
      <canvas class="particles-js-canvas-el" style="z-index: 2;width: 100%;height: 100%;position: fixed;" width="1560"
        height="560">
      </canvas>
    </div>
    <!-- <div style="position: fixed;top:13vh;z-index: 10;"> -->
    <!-- 系统设置菜单 -->
    <div class="home-title">
      <div class="title-img" @click="handleToSettings()"></div>
    </div>
    <!-- 系统模块菜单 -->
    <div class="home-module-box">
      <draggable v-model="dataList" :group="groupA" :sort="true" :disabled="isBJ" class=" dataWrap" animation="500"
        @end="refreshKay">
        <div class="itemBox" v-for="(item, index) in dataList" :key="index">

          <!-- 外部系统链接 -->
          <a v-if="item.source == 2 && item.accessUrl.indexOf('http') != -1" :href="item.accessUrl" target="_blank">
            <img :src="'/pageIcons/' + item.logoUrl" @contextmenu="showContextMenu($event, item)" />
            <span>{{ item.appName }}</span>
          </a>
          <a v-else-if="item.source == 2 && item.accessUrl.indexOf('http') == -1" :href="'https://' + item.accessUrl"
            target="_blank">
            <img :src="'/pageIcons/' + item.logoUrl" @contextmenu="showContextMenu($event, item)" />
            <span>{{ item.appName }}</span>
          </a>
          <div v-else>
            <img @click="goRouter(item.accessUrl, item)" :src="'/pageIcons/' + item.logoUrl"
              @contextmenu="showContextMenu($event, item)" />
            <span @click="goRouter(item.accessUrl, item)">{{ item.appName }}</span>
          </div>
        </div>
        <div class="list" v-for="(item, index) in row - (len % row)" :key="index + 0.1">

        </div>
      </draggable>
      <!-- 右键菜单的内容 -->
      <div v-if="contextMenuVisible" class="context-menu"
        :style="{ 'position': 'absolute', top: contextMenuPosition.y - 430 + 'px', left: contextMenuPosition.x - 670 + 'px' }">
        <div class="close" @click="contextMenuVisible = false"></div>
        <p class="text">是否隐藏该系统入口？</p>
        <div class="footbtn">
          <div class="no" @click="contextMenuVisible = false">否</div>
          <div class="yes" @click="hideapp()">是</div>

        </div>
      </div>
    </div>

    <!-- 系统更新通知自定义弹窗 -->
    <div v-if="updateNoticeVisible" class="custom-modal-mask">
      <div class="custom-modal-wrapper">
        <div class="custom-modal-container">
          <!-- 关闭按钮 -->
          <div class="modal-close" @click="handleCloseUpdateNotice">
            <img src="@/assets/sysUpdate/close.svg" alt="关闭" />
          </div>
          
          <!-- 标题区域 -->
          <div class="update-notice-header">
            <div class="header-bg">
              <img src="@/assets/sysUpdate/ban.svg" alt="header-bg" class="header-bg-img" />
              <div class="update-time" v-if="updateNoticeData.versionTime">
                更新时间: {{ updateNoticeData.versionTime }}
              </div>
            </div>
            <div class="header-content">
              <h2 class="update-title">系统更新通知</h2>
            </div>
          </div>

          <!-- 内容区域 -->
          <div class="update-notice-body">
            <div class="body-card">
              <div class="update-content-title">
                <img src="@/assets/sysUpdate/update.svg" alt="icon" class="title-icon" />
                更新内容
              </div>

              <!-- 新增功能 -->
              <div class="update-section" v-if="updateNoticeData.newFeatures">
                <div class="section-header">
                  <span class="section-icon">
                    <img src="@/assets/sysUpdate/add.svg" alt="icon" />
                  </span>
                  <span class="section-title" style="color: #f90;">新增功能</span>
                </div>
                <div class="section-content" v-html="updateNoticeData.newFeatures"></div>
              </div>

              <!-- 系统优化 -->
              <div class="update-section" v-if="updateNoticeData.systemTuning">
                <div class="section-header">
                  <span class="section-icon">
                    <img src="@/assets/sysUpdate/optimize.svg" alt="icon" />
                  </span>
                  <span class="section-title" style="color: #52c41a;">系统优化</span>
                </div>
                <div class="section-content" v-html="updateNoticeData.systemTuning"></div>
              </div>

              <!-- 问题修复 -->
              <div class="update-section" v-if="updateNoticeData.issueFixing">
                <div class="section-header">
                  <span class="section-icon">
                    <img src="@/assets/sysUpdate/problemfixed.svg" alt="icon" />
                  </span>
                  <span class="section-title" style="color: #1890ff;">问题修复</span>
                </div>
                <div class="section-content" v-html="updateNoticeData.issueFixing"></div>
              </div>
              
              <div class="doc-view-link" v-if="updateNoticeData.documentation">
                <a @click="handleViewDoc">查看更新说明文档 >></a>
              </div>
            </div>
          </div>

          <!-- 底部操作区域 -->
          <div class="update-notice-footer">
            <div class="footer-left">
              <a-checkbox v-model="notShowAgain" class="custom-checkbox">本次更新不再提示</a-checkbox>
            </div>
            <div class="footer-right">
              <div class="custom-btn close-btn" @click="handleCloseUpdateNotice">关闭</div>
              <div class="custom-btn download-btn" @click="handleDownloadDoc" v-if="updateNoticeData.documentation">
                下载更新说明文档
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 文档查看弹窗 -->
    <a-modal
      title="更新说明文档"
      :width="900"
      :visible="docViewVisible && updateNoticeData.documentation"
      :footer="null"
      :maskClosable="true"
      :closable="true"
      :centered="true"
      :zIndex="10001"
      @cancel="docViewVisible = false"
      class="doc-view-modal"
    >
      <div class="doc-view-content">
        <iframe
          v-if="updateNoticeData.documentation"
          :src="getDocViewUrl(updateNoticeData.documentation)"
          frameborder="0"
          style="width: 100%; height: 70vh; border: none;"
        ></iframe>
        <div v-else class="doc-empty">
          <a-empty description="暂无文档" />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>

import particles from 'particles.js'
import AvatarDropdown from '@/components/GlobalHeader/AvatarDropdown'
import managerLogoSvg from '@/assets/myImg/logoManager.svg?inline'
import iconCaretRightWhite from '@/assets/myImg/1/icon-caret-right-white.svg?inline'
import draggable from 'vuedraggable'

export default {
  name: 'HomePage',
  components: {
    managerLogoSvg,
    iconCaretRightWhite,
    AvatarDropdown,
    draggable
  },
  computed: {
    title() {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser() {
      return this.$store.getters.userInfo
    }
  },
  data: function () {
    return {
      contextMenuVisible: false,
      contextMenuPosition: { x: 0, y: 0 },
      isBJ: false,
      groupA: {
        name: 'pagehome',
        pull: true, // 可以拖出
        put: false // 可以拖入
      },
      len: 0,
      row: 4,
      dataList: [],
      showMenu: true,
      queryUrl: 'manager/users/app',
      imageUrl: '',
      imageLoaded: false,
      particleJson: {
        'particles': {
          'number': {
            'value': 800, // 数量
            'density': {
              'enable': true, // 启用粒子的稀密程度
              'value_area': 800 // 区域散布密度大小
            }
          },
          'color': {
            'value': '#00aeff' // 原子的颜色
          },
          'shape': {
            'type': 'circle', // 原子的形状 "circle" ,"edge" ,"triangle" ,"polygon" ,"star" ,"image" ,["circle", "triangle", "image"]
            'stroke': {
              'width': 0, // 原子的宽度
              'color': '#362cff' // 原子颜色
            },
            'polygon': {
              'nb_sides': 5 // 原子的多边形边数
            },
            'image': {
              'src': 'img/github.svg', // 原子的图片可以使用自定义图片 "assets/img/yop.svg" , "http://mywebsite.com/assets/img/yop.png"
              'width': 100, // 图片宽度
              'height': 100 // 图片高度
            }
          },
          'opacity': {
            'value': 1, // 不透明度
            'random': true, // 随机不透明度
            'anim': {
              'enable': true, // 渐变动画
              'speed': 1, // 渐变动画速度
              'opacity_min': 0, // 渐变动画不透明度
              'sync': true
            }
          },
          'size': {
            'value': 3, // 原子大小
            'random': true, // 原子大小随机
            'anim': {
              'enable': false, // 原子渐变
              'speed': 4, // 原子渐变速度
              'size_min': 0.3,
              'sync': false
            }
          },
          'line_linked': {
            'enable': false, // 连接线
            'distance': 150, // 连接线距离
            'color': 'transparent', // 连接线颜色
            'opacity': 0.4, // 连接线不透明度
            'width': 1 // 连接线的宽度
          },
          'move': {
            'enable': true, // 原子移动
            'speed': 1, // 原子移动速度
            'direction': 'none', // 原子移动方向   "none" ,"top" ,"top-right" ,"right" ,"bottom-right" ,"bottom" ,"bottom-left" ,"left" ,"top-left"
            'random': true, // 移动随机方向
            'straight': false, // 直接移动
            'out_mode': 'out', // 是否移动出画布
            'bounce': false, // 是否跳动移动
            'attract': {
              'enable': false, // 原子之间吸引
              'rotateX': 600, // 原子之间吸引X水平距离
              'rotateY': 600 // 原子之间吸引Y水平距离
            }
          }
        },
        'interactivity': {
          'detect_on': 'canvas', // 原子之间互动检测 "canvas", "window"
          'events': {
            'onhover': {
              'enable': true, // 悬停
              'mode': 'bubble' // 悬停模式      "grab"抓取临近的,"bubble"泡沫球效果,"repulse"击退效果,["grab", "bubble"]
            },
            'onclick': {
              'enable': false, // 点击效果
              'mode': 'repulse' // 点击效果模式   "push" ,"remove" ,"bubble" ,"repulse" ,["push", "repulse"]
            },
            'resize': true // 互动事件调整
          },
          'modes': {
            'grab': {
              'distance': 100, // 原子互动抓取距离
              'line_linked': {
                'opacity': 0.8 // 原子互动抓取距离连线不透明度
              }
            },
            'bubble': {
              'distance': 250, // 原子抓取泡沫效果之间的距离
              'size': 4, // 原子抓取泡沫效果之间的大小
              'duration': 2, // 原子抓取泡沫效果之间的持续事件
              'opacity': 1, // 原子抓取泡沫效果透明度
              'speed': 1
            },
            'repulse': {
              'distance': 400, // 击退效果距离
              'duration': 0.4 // 击退效果持续事件
            },
            'push': {
              'particles_nb': 2 // 粒子推出的数量
            },
            'remove': {
              'particles_nb': 2
            }
          }
        },
        'retina_detect': true
      },
      starList: [
        { x: 610, y: 570 },
        { x: 440, y: 600 },
        { x: 320, y: 450 },
        { x: 260, y: 350 },
        { x: 310, y: 440 },
        { x: 420, y: 510 },
        { x: 780, y: 500 },
        { x: 680, y: 640 }
      ],
      appClickdata: '',
      // 系统更新通知相关
      updateNoticeVisible: false,
      updateNoticeData: {},
      notShowAgain: false,
      docViewVisible: false,
      showUpdateGuide: false,
    }
  },
  mounted() {
    for (var i = 0; i < 100; i++) {
      var x = Math.random() * 600 + 200
      var y = Math.random() * 600 + 200
      this.starList.push({ x, y })
    }
    window.particlesJS('particlesId', this.particleJson)
    // 监听点击页面其他部分，以隐藏右键菜单
    window.addEventListener('click', this.hideContextMenu);
  },

  created() {
    this.getTenantHomeImage()
    this.getUserList()
    // 获取系统更新通知
    this.getUpdateNotice()
  },
  methods: {
    showContextMenu(event, item) {
      this.appClickdata = item
      // 阻止默认右键菜单
      event.preventDefault();
      // 获取右键点击的位置
      this.contextMenuPosition.x = event.clientX;
      this.contextMenuPosition.y = event.clientY;
      // 显示右键菜单
      this.contextMenuVisible = true;
    },
    hideapp() {
      this.appClickdata.status = 2
      this.$http
        .post('manager/users/tenant/update/sys', this.appClickdata)
        .then(({ data }) => { 
          this.getUserList()
        })
        .catch(() => { })
    },
    hideContextMenu() {
      // 隐藏右键菜单
      this.contextMenuVisible = false;
    }, 
    refreshKay() { 
      let newarr = []
      this.dataList.map((item, i) => {
        newarr.push({
          "appCode": item.appCode,
          "appName": item.appName,
          "sort": i + 1
        })
      })
      this.$http
        .post('manager/users/tenant/update/list', newarr)
        .then(({ data }) => {
          console.log('111', data);
        })
        .catch(() => { })
    },
    getTenantHomeImage() {
      // 重置图片加载状态
      this.imageLoaded = false
      this.$http
        .get('manager/tenants/home_image')
        .then(({ data }) => {
          if (data) {
            this.imageUrl = data.configValue
          } else {
            this.imageUrl =
              'https://linkeda-resource2.oss-cn-shenzhen.aliyuncs.com/smart-water/file/resource/2025-05-07/3010c1377f1345768ee4851d6c697da9.jpg'
          }
        })
        .catch(() => { 
          // 加载失败时也重置状态
          this.imageLoaded = false
        })
    },
    // 图片加载完成
    handleImageLoad(event) {
      this.imageLoaded = true
      // 图片加载完成后，显示图片
      if (event && event.target) {
        event.target.style.opacity = '1'
      }
    },
    // 图片加载失败
    handleImageError(event) {
      this.imageLoaded = false
      // 加载失败时使用默认图片
      const defaultImage = 'https://linkeda-resource2.oss-cn-shenzhen.aliyuncs.com/smart-water/file/resource/2025-05-07/3010c1377f1345768ee4851d6c697da9.jpg'
      if (this.imageUrl !== defaultImage) {
        this.imageUrl = defaultImage
      } else {
        // 如果默认图片也加载失败，显示图片（即使加载失败也要显示，避免空白）
        if (event && event.target) {
          event.target.style.opacity = '1'
        }
      }
    },
    // 获取用户应用
    getUserList() {
      this.$http
        .get(`${this.queryUrl}`)
        .then(({ data }) => {
          this.dataList = data 
          this.len = this.dataList.length
        })
        .catch(() => { })
    },
    getWordCnt(arr) {
      var obj = {}
      for (var i = 0, l = arr.length; i < l; i++) {
        var item = arr[i]
        obj[item] = (obj[item] + 1) || 1
      }
      return obj
    },
    handleToSettings() {
      this.$router.push({ path: '/account/settings' })
    },
    goRouter(url, item) {
      console.log(`zhu->${item.accessUrl}`, item.appName)
      const params = { appId: item.id }
      this.$http
        .get('/manager/users/has/visit', { params })
        .then(({ data }) => {
          if (data) {
            this.$router.push({ path: url })
          } else {
            this.$warning({
              title: '暂无权限,请联系管理员'
            })
          }
        })
        .catch(() => { })
    },
    // 获取系统更新通知
    getUpdateNotice() {
      // 检查是否已经设置不再提示
      const notShowUpdateId = localStorage.getItem('notShowUpdateId')      
      this.$http
        .get('/manager/sys_update_push/selectUpdatePushBytenant')
        .then(({ data }) => {
          // 只有当 isPop === 0 时才自动显示弹窗
          if (data && data.id && (data.isPop === 0 || data.isPop === '0')) {
            // 如果当前更新通知ID与已设置的不再提示ID相同，则不显示
            if (notShowUpdateId && notShowUpdateId === String(data.id)) {
              return
            }
            
            this.updateNoticeData = data
            this.updateNoticeVisible = true
          }
        })
        .catch(() => { })
    },
    // 手动显示系统更新通知（从入口点击）
    handleShowUpdateNotice() {
      // 直接获取并显示更新通知，不检查不再提示状态
      this.$http
        .get('/manager/sys_update_push/selectUpdatePushBytenant')
        .then(({ data }) => {
          if (data && data.id) {
            this.updateNoticeData = data
            this.updateNoticeVisible = true
            // 重置不再提示状态
            if (data.isPop=='1') {
              this.notShowAgain = true
            }
          } else {
            this.$message.info('暂无系统更新通知')
          }
        })
    },
    // 关闭更新通知
    handleCloseUpdateNotice() {
      // 关闭弹窗时调用接口
      if (this.updateNoticeData.id) {
        // 如果 isShow 为 "1"，不调用 updateUpdatePushBytenantOne 接口
        const isShow = this.updateNoticeData.isShow
        const shouldCallUpdateOne = isShow !== "1" && isShow !== 1
        
        let promise = Promise.resolve()
        
        // 如果 isShow 不为 "1"，调用 updateUpdatePushBytenantOne 接口
        if (shouldCallUpdateOne) {
          promise = this.$http.get('/manager/sys_update_push/updateUpdatePushBytenantOne', {
            params: {
              id: this.updateNoticeData.id
            }
          })
        }
        
        promise
          .then(() => {
            // 如果勾选了不再提示，且 isPop 不为 '1'，调用另一个接口记录
            const isPop = this.updateNoticeData.isPop
            if (this.notShowAgain && isPop !== '1' && isPop !== 1) {
              return this.$http.get('/manager/sys_update_push/updateUpdatePushBytenant', {
                params: {
                  id: this.updateNoticeData.id
                }
              })
            }
          })
          .then(({ data }) => {
            // 如果勾选了不再提示，保存到localStorage作为本地备份
            if (this.notShowAgain) {
              localStorage.setItem('notShowUpdateId', String(this.updateNoticeData.id))
            }
            this.updateNoticeVisible = false
            this.checkAndShowGuide()
          })
          .catch(() => {
            // 即使接口失败，也关闭弹窗，但提示用户
            this.updateNoticeVisible = false
            this.checkAndShowGuide()
          })
      } else {
        // 没有ID，直接关闭
        this.updateNoticeVisible = false
        this.checkAndShowGuide()
      }
    },
    // 检查是否显示引导
    checkAndShowGuide() {
      const hasShownGuide = localStorage.getItem('hasShownUpdateGuide')
      if (!hasShownGuide) {
        this.showUpdateGuide = true
      }
    },
    // 关闭引导
    handleCloseGuide() {
      this.showUpdateGuide = false
      localStorage.setItem('hasShownUpdateGuide', 'true')
    },
    // 在线查看更新说明文档
    handleViewDoc() {
      if (this.updateNoticeData.documentation) {
        this.docViewVisible = true
      }
    },
    // 下载更新说明文档
    handleDownloadDoc() {
      if (this.updateNoticeData.documentation) {
        // 创建一个临时链接用于下载
        const link = document.createElement('a')
        link.href = this.updateNoticeData.documentation
        link.download = this.getFileName(this.updateNoticeData.documentation) || '更新说明文档'
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
    // 获取文档查看URL（支持PDF在线预览）
    getDocViewUrl(url) {
      if (!url) return ''
      const lowerUrl = url.toLowerCase()
      
      // 如果是PDF文件，使用浏览器内置预览
      if (lowerUrl.endsWith('.pdf')) {
        // 直接返回PDF URL，浏览器会自动使用内置PDF查看器
        return url
      }
      
      // 如果是Office文档，尝试使用Office在线预览
      if (lowerUrl.endsWith('.doc') || lowerUrl.endsWith('.docx') || 
          lowerUrl.endsWith('.xls') || lowerUrl.endsWith('.xlsx') ||
          lowerUrl.endsWith('.ppt') || lowerUrl.endsWith('.pptx')) {
        // 使用Office在线预览服务
        return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`
      }
      
      // 其他文件类型直接返回原URL
      return url
    },
    // 获取文件名
    getFileName(url) {
      if (!url) return ''
      const parts = url.split('/')
      return parts[parts.length - 1]
    }
  },
  activated() {
    // 当从其他页面返回首页时，重新获取图片（避免缓存问题）
    if (this.imageUrl) {
      // 重置加载状态
      this.imageLoaded = false
      // 强制重新加载图片，避免显示缓存的缩略图
      this.$nextTick(() => {
        const img = this.$refs.backgroundImage
        if (img) {
          // 通过添加时间戳或重新设置src来强制刷新图片
          const separator = this.imageUrl.includes('?') ? '&' : '?'
          img.src = `${this.imageUrl}${separator}_t=${Date.now()}`
        }
      })
    } else {
      // 如果没有图片URL，重新获取
      this.getTenantHomeImage()
    }
  },
  beforeDestroy() {
    // 移除监听器，以防止内存泄漏
    window.removeEventListener('click', this.hideContextMenu);
  }
}
</script>

<style lang="less" scoped>
.particles-wrapper {
  position: absolute;
  background-color: transparent;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.particles-js-canvas-el {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
}

.xzyq {
  position: fixed;
  top: -500px;
  right: -400px;
  background-image: url('~@/assets/light2.png');
  background-position: left bottom;
  background-size: cover;
  user-select: none;
}

.header-right-menu {
  position: absolute;
  right: 30px;
  top: 30px;
  display: flex;
  align-items: center;
  gap: 16px;
  user-select: none;
}

.sys-update-wrapper {
  position: relative;
}

.sys-update-entry {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
  }
  
  &.highlight {
    background: rgba(18, 161, 255, 1);
    box-shadow: 0 0 15px rgba(18, 161, 255, 0.6);
    animation: pulse 2s infinite;
  }
  
  img {
    width: 24px;
    height: 24px;
    filter: brightness(0) invert(1); // 将图标变为白色
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(18, 161, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(18, 161, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(18, 161, 255, 0);
  }
}

.update-guide-popover {
  position: absolute;
  top: 55px;
  right: -20px;
  width: 220px;
  padding: 12px;
  background: rgba(0, 21, 41, 0.85);
  border: 1px dashed rgba(255, 255, 255, 0.6);
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  text-align: left;
  z-index: 999;
  animation: fade-in 0.3s;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  
  .popover-content {
    margin-bottom: 10px;
    line-height: 1.5;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
  
  .popover-btn {
    background: #00aeff;
    color: #fff;
    padding: 4px 16px;
    border-radius: 20px;
    float: right;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: all 0.3s;
    
    &:hover {
      background: #0095e0;
      transform: scale(1.05);
    }
  }
  
  .popover-arrow {
    position: absolute;
    top: -6px;
    right: 28px;
    width: 10px;
    height: 10px;
    background: rgba(0, 21, 41, 0.85);
    border-top: 1px dashed rgba(255, 255, 255, 0.6);
    border-left: 1px dashed rgba(255, 255, 255, 0.6);
    transform: rotate(45deg);
    z-index: 1;
  }
}

@keyframes fade-in {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.zhcd {
  user-select: none;
}

.rotate {
  position: relative;
  animation: rotate linear infinite 50s;

  img {
    width: 980px;
    height: auto;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0);
    opacity: 0.9;
  }

  50% {
    transform: rotate(180deg);
    opacity: 1;
  }

  100% {
    transform: rotate(360deg);
    opacity: 0.9;
  }
}

.primary {
  background: url(~@/assets/myImg/1/content-box-07.png) no-repeat;
  background-size: cover;
  width: 48px;
  height: 48px;
  top: 50%;
  left: 20%;
  position: absolute;
}

.primarys {
  background: url(~@/assets/myImg/1/content-box-08.png) no-repeat;
  background-size: cover;
  width: 48px;
  height: 48px;
  top: 50%;
  right: 20%;
  position: absolute;
}

.home-title {
  display: flex;
  justify-content: center;
  z-index: 10;
  position: relative;
  top: 7vh;

  .title-img {
    height: 12.4vh;
    width: 62.5vw;
    cursor: pointer;
    background: url(/iconImg/h_h_title_bt.png) no-repeat;
    background-size: 100% 100%;
  }
}

.home-module-box {
  // display: grid;
  // grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  // gap: 30px;
  z-index: 10;
  width: 45vw;
  margin-left: 28vw;
  position: absolute;
  top: 24vh;
  // transform: translateY(0%);

  .context-menu {
    width: 278px;
    height: 188px;
    background-image: url('~@/assets/homepage/bg.png');
    position: relative;

    .close {
      position: absolute;
      top: 22px;
      right: 22px;
      width: 20px;
      height: 19px;
      cursor: pointer;
      background-image: url('~@/assets/homepage/close.png');

    }

    .text {
      color: #fff;
      text-align: center;
      margin-top: 60px;
      font-size: 15px;
    }

    .footbtn {
      color: #fff;
      display: flex;
      justify-content: center;
      margin-top: 20px;

      .no,
      .yes {
        width: 84px;
        height: 44px;
        background-image: url('~@/assets/homepage/nobg.png');
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }

      .yes {
        margin-left: 25px
      }

      .no:hover,
      .yes:hover {
        width: 84px;
        height: 44px;
        background-image: url('~@/assets/homepage/nobg2.png');
      }
    }
  }

  .dataWrap {
    width: 100%;
    height: 100%;

    padding-top: 0;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;

  }

  .itemBox {
    width: 25%;
    min-width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 16px 0;

    div,
    a {
      display: flex;
      flex-flow: column;
      align-items: center;
    }

    img {
      height: 8.7vh;
      width: 4.9vw;
      min-width: 48px;
      min-height: 48px;
      cursor: pointer;
    }

    span {
      font-family: MicrosoftYaHeiSemibold;
      font-size: 18px;
      color: #fcfffe;
      letter-spacing: 0.71px;
      text-align: center;
      font-weight: 600;
      cursor: pointer;
    }
  }

  .list {
    content: '';
    width: 25%;
  }
}

.container {
  position: absolute;
  overflow: hidden;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background-size: 100% 100%;
  object-fit: cover;
  /* 防止图片在加载时显示缩略图或占位符 */
  background-color: #000;
  /* 初始状态隐藏，加载完成后显示 */
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  
  &.image-loaded {
    opacity: 1;
  }
}

/* 系统更新通知弹窗样式 */
.custom-modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-modal-wrapper {
  width: 800px;
  max-width: 90vw;
  animation: modal-fade-in 0.3s ease-out;
  position: relative;
  z-index: 10000;
}

@keyframes modal-fade-in {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}

.custom-modal-container {
  position: relative;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  z-index: 20;
  transition: transform 0.3s;
  
  &:hover {
    transform: rotate(90deg);
  }
  
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.update-notice-header {
  position: relative;
  height: 120px;
  background: linear-gradient(180deg, #00156a 0%, #160b6e 100%);
  overflow: hidden;
  flex-shrink: 0;

  .header-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    pointer-events: none;
    
    .header-bg-img {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
    
    .update-time {
      font-size: 14px;
      color: #fff;
      opacity: 0.9;
      margin-top: 8px;
      pointer-events: auto;
      padding-bottom: 8px;
    }
  }

  .header-content {
    position: relative;
    z-index: 1;
    text-align: center;
    padding-top: 16px;
    width: 100%;
  }

  .update-title {
    font-size: 32px;
    font-weight: 700;
    margin: 0;
    color: #00aeff;
    text-shadow: 0 0 10px rgba(0, 174, 255, 0.5);
    font-family: 'Microsoft YaHei', sans-serif;
    letter-spacing: 2px;
  }
}

.update-notice-body {
  padding: 12px;
  background-color: #fff;
  
  .body-card {
    background-color: #fff;
    border-radius: 8px;
    padding: 12px;
    min-height: 200px;
    max-height: 60vh;
    overflow-y: auto;
  }

  .update-content-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #00aeff;
    display: flex;
    align-items: center;
    
    .title-icon {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
  
  .doc-view-link {
    text-align: center;
    margin-top: 12px;
    
    a {
      color: #00aeff;
      font-size: 14px;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .update-section {
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }

    .section-header {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      background: #f9f9f9;
      border-radius: 20px;
      padding: 4px 0 4px 12px;
      .section-icon {
        margin-right: 6px;
        display: flex;
        align-items: center;
        
        img {
          width: 18px;
          height: 18px;
        }
      }

      .section-title {
        font-size: 15px;
        font-weight: 600;
      }
    }

    .section-content {
      padding-left: 24px; 
      line-height: 1.6;
      font-size: 14px;
      
      /deep/ ol,
      /deep/ ul {
        margin: 4px 0;
        padding-left: 18px;
      }

      /deep/ li {
        margin: 2px 0;
      }

      /deep/ p {
        margin: 4px 0;
      }
    }
  }
}

.update-notice-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 30px;
  background: linear-gradient(90deg, #000b4d 0%, #1a0b5c 100%);
  
  .custom-checkbox {
    color: #fff;
    
    /deep/ .ant-checkbox-inner {
      background-color: transparent;
      border-color: #fff;
    }
    
    /deep/ .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #00aeff;
      border-color: #00aeff;
    }
    
    /deep/ span {
      color: #fff;
    }
  }
  
  .footer-right {
    display: flex;
    gap: 15px;
    
    .custom-btn {
      height: 36px;
      padding: 0 20px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.3s;
      
      &.close-btn {
        border: 1px solid #00aeff;
        color: #00aeff;
        background: transparent;
        
        &:hover {
          background: rgba(0, 174, 255, 0.1);
        }
      }
      
      &.download-btn {
        background: linear-gradient(90deg, #00aeff 0%, #0066ff 100%);
        color: #fff;
        border: none;
        
        &:hover {
          opacity: 0.9;
          box-shadow: 0 0 10px rgba(0, 102, 255, 0.5);
        }
      }
    }
  }
}

/* 文档查看弹窗样式 */
.doc-view-modal {
  /deep/ .ant-modal-wrap {
    z-index: 10001 !important;
  }
  
  /deep/ .ant-modal-mask {
    z-index: 10001 !important;
  }
  
  /deep/ .ant-modal {
    z-index: 10001 !important;
  }
  
  /deep/ .ant-modal-body {
    padding: 0;
  }
}

.doc-view-content {
  width: 100%;
  min-height: 70vh;
  background: #f5f5f5;

  .doc-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 70vh;
  }
}
</style>
